import type {CSSProperties} from 'react'

import {CELL_HEIGHT, TABLE_HEADER_HEIGHT} from '../../../components/table/constants'
import {columnWidthVariable} from './column-width-variable'

/**
 * Provides the styles for a block layout cell given a column id
 * Based on TanStack Table v7 API:
 * - docs: https://react-table-v7-docs.netlify.app/docs/api/useblocklayout
 * - source: https://github.com/TanStack/table/blob/v7/src/plugin-hooks/useBlockLayout.js
 */
export const getCellStylesFromColumn = (columnId: string): CSSProperties => ({
  display: 'inline-block',
  boxSizing: 'border-box',
  height: CELL_HEIGHT,
  width: `calc(var(${columnWidthVariable(columnId)}) * 1px)`,
})

type HeaderCellPropsFromColumn = {columnId: string; colSpan: number}
type HeaderCellPropsFromColumnReturnType = {style: CSSProperties; colSpan: number}
/**
 * Provides the styles and properties for a resizable header cell given a column id
 * Based on TanStack Table v7 APIs:
 * - docs: https://react-table-v7-docs.netlify.app/docs/api/useResizeColumns
 * - source: https://github.com/TanStack/table/blob/v7/src/plugin-hooks/useResizeColumns.js
 * - source: https://github.com/TanStack/table/blob/v7/src/makeDefaultPluginHooks.js
 */
export const getHeaderCellPropsFromColumn = ({
  columnId,
  colSpan,
}: HeaderCellPropsFromColumn): HeaderCellPropsFromColumnReturnType => ({
  style: {
    ...getCellStylesFromColumn(columnId),
    height: TABLE_HEADER_HEIGHT,
    position: 'relative',
  },
  colSpan,
})
